export default __webpack_public_path__ + "static/media/BoxArt-Conspiracy.f9f68d1d.png";